import { forwardRef, type Ref, type SVGProps } from "react";
const IconHandshakeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M9.478 10.485c-.592.56-1.512 2.018-.465 3.364 1.309 1.682 3.125 1.01 3.633.799.405-.168 2.027-1.528 2.788-2.187l3.842 1.769a.5.5 0 0 1 .15.106c1.824 1.887 5.448 5.633 5.85 6.032.506.505.507 1.304.253 1.64-.253.337-1.183.799-1.774.294-.593-.506-4.942-4.54-5.491-5.088-.55-.547-1.31.126-.718.546l5.28 4.963c-.38.309-1.225.976-1.563 1.178-.423.252-.718.084-1.183-.252-1.464-1.458-4.477-4.45-4.815-4.753-.423-.378-1.267-.084-.718.505l4.52 4.541c-.184.21-.626.682-.93.884-.38.252-1.14.42-1.563 0-.422-.42-3.802-3.996-4.393-4.71-.592-.715-1.478-.169-.802.462l3.759 4.08c-.845.967-1.69 1.009-2.28.588-.474-.336-3.042-2.607-4.267-3.7-.887-1.332-2.78-4.155-3.253-4.795S3.274 14.033 2.5 13.826V8.888h8.94z"
    />
    <path
      fill="currentColor"
      d="M15.856 6.765c1.342-.458 2.226-.22 3.633-.041 2.815.357 6.674 2.86 6.674 2.86H29.5l-.042 6.519-2.154.083-2.281 2.566-5.28-5.257-3.549-1.767-.835-.432c-.38.253-1.996 1.526-2.713 2.157-.719.63-2.07.672-2.704.084-.633-.59-.506-1.85.127-2.397.507-.437 3.084-2.594 4.309-3.617.497-.416.864-.548 1.478-.758"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHandshakeFilledSVG);
ForwardRef.displayName = "IconHandshakeFilled";
export { ForwardRef as IconHandshakeFilled };
